import { Fragment } from "react";
import { jackColors } from "../../../../assets/colors";
import { GothamRegular } from "../../../../components/Text";
import styles from "../../styles.module.css";

const AlertRed = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8 13.5829L12.4083 2.98292C12.1499 2.5786 11.7938 2.24585 11.3729 2.01536C10.952 1.78488 10.4799 1.66406 10 1.66406C9.52014 1.66406 9.048 1.78488 8.62711 2.01536C8.20622 2.24585 7.85013 2.5786 7.59168 2.98292L1.20001 13.5829C0.974224 13.9593 0.851503 14.3885 0.844189 14.8273C0.836875 15.2662 0.945225 15.6992 1.15835 16.0829C1.40474 16.5148 1.76139 16.8735 2.19185 17.1224C2.6223 17.3713 3.11112 17.5015 3.60835 17.4996H16.3917C16.8856 17.5049 17.3722 17.3797 17.8024 17.1369C18.2326 16.894 18.591 16.5419 18.8417 16.1162C19.0611 15.7286 19.1729 15.2893 19.1655 14.8439C19.1582 14.3985 19.032 13.9632 18.8 13.5829ZM10 14.1662C9.83519 14.1662 9.67408 14.1174 9.53704 14.0258C9.39999 13.9342 9.29319 13.8041 9.23011 13.6518C9.16704 13.4995 9.15054 13.332 9.18269 13.1703C9.21484 13.0087 9.29421 12.8602 9.41076 12.7437C9.5273 12.6271 9.67579 12.5477 9.83744 12.5156C9.99909 12.4834 10.1666 12.4999 10.3189 12.563C10.4712 12.6261 10.6013 12.7329 10.6929 12.8699C10.7845 13.007 10.8333 13.1681 10.8333 13.3329C10.8333 13.5539 10.7455 13.7659 10.5893 13.9222C10.433 14.0785 10.221 14.1662 10 14.1662ZM10.8333 10.8329C10.8333 11.0539 10.7455 11.2659 10.5893 11.4222C10.433 11.5785 10.221 11.6662 10 11.6662C9.779 11.6662 9.56704 11.5785 9.41076 11.4222C9.25448 11.2659 9.16668 11.0539 9.16668 10.8329V7.49958C9.16668 7.27857 9.25448 7.06661 9.41076 6.91033C9.56704 6.75405 9.779 6.66625 10 6.66625C10.221 6.66625 10.433 6.75405 10.5893 6.91033C10.7455 7.06661 10.8333 7.27857 10.8333 7.49958V10.8329Z"
        fill="#E73126"
      />
    </svg>
  );
};

const QuestionMark = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00001 1.3335C6.68147 1.3335 5.39254 1.72449 4.29621 2.45703C3.19988 3.18957 2.3454 4.23077 1.84082 5.44894C1.33623 6.66711 1.20421 8.00756 1.46144 9.30077C1.71868 10.594 2.35362 11.7819 3.28597 12.7142C4.21832 13.6466 5.4062 14.2815 6.69941 14.5387C7.99262 14.796 9.33306 14.6639 10.5512 14.1594C11.7694 13.6548 12.8106 12.8003 13.5431 11.704C14.2757 10.6076 14.6667 9.31871 14.6667 8.00016C14.6667 7.12468 14.4942 6.25778 14.1592 5.44894C13.8242 4.6401 13.3331 3.90517 12.7141 3.28612C12.095 2.66706 11.3601 2.176 10.5512 1.84097C9.7424 1.50593 8.87549 1.3335 8.00001 1.3335ZM8.00001 13.3335C6.94518 13.3335 5.91403 13.0207 5.03697 12.4347C4.15991 11.8486 3.47632 11.0157 3.07266 10.0411C2.66899 9.0666 2.56337 7.99425 2.76916 6.95968C2.97495 5.92512 3.4829 4.97481 4.22878 4.22893C4.97466 3.48305 5.92497 2.9751 6.95953 2.76931C7.9941 2.56352 9.06645 2.66914 10.041 3.07281C11.0155 3.47647 11.8485 4.16006 12.4345 5.03712C13.0206 5.91418 13.3333 6.94533 13.3333 8.00016C13.3333 9.41465 12.7714 10.7712 11.7713 11.7714C10.7711 12.7716 9.4145 13.3335 8.00001 13.3335ZM8.00001 4.00017C7.38117 4.00017 6.78768 4.246 6.35009 4.68358C5.91251 5.12117 5.66668 5.71466 5.66668 6.3335C5.66668 6.51031 5.73691 6.67988 5.86194 6.8049C5.98696 6.92993 6.15653 7.00017 6.33334 7.00017C6.51015 7.00017 6.67972 6.92993 6.80475 6.8049C6.92977 6.67988 7.00001 6.51031 7.00001 6.3335C7.00001 6.13572 7.05866 5.94238 7.16854 5.77793C7.27842 5.61348 7.4346 5.48531 7.61733 5.40962C7.80005 5.33393 8.00112 5.31413 8.1951 5.35272C8.38908 5.3913 8.56726 5.48654 8.70712 5.62639C8.84697 5.76625 8.94221 5.94443 8.98079 6.13841C9.01938 6.33239 8.99958 6.53346 8.92389 6.71618C8.8482 6.89891 8.72003 7.05509 8.55558 7.16497C8.39113 7.27485 8.19779 7.3335 8.00001 7.3335C7.8232 7.3335 7.65363 7.40374 7.52861 7.52876C7.40358 7.65379 7.33334 7.82336 7.33334 8.00017V9.3335C7.33334 9.51031 7.40358 9.67988 7.52861 9.80491C7.65363 9.92993 7.8232 10.0002 8.00001 10.0002C8.17682 10.0002 8.34639 9.92993 8.47141 9.80491C8.59644 9.67988 8.66668 9.51031 8.66668 9.3335V8.56017C9.20541 8.40284 9.66912 8.05607 9.97234 7.58379C10.2755 7.11151 10.3978 6.54555 10.3166 5.99021C10.2355 5.43488 9.95627 4.9276 9.53054 4.56189C9.10481 4.19618 8.56124 3.99668 8.00001 4.00017ZM8.66668 11.3335C8.66668 11.7017 8.3682 12.0002 8.00001 12.0002C7.63182 12.0002 7.33334 11.7017 7.33334 11.3335C7.33334 10.9653 7.63182 10.6668 8.00001 10.6668C8.3682 10.6668 8.66668 10.9653 8.66668 11.3335Z"
        fill="#343434"
      />
    </svg>
  );
};

const ExclamationMark = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99996 1.6665C8.35179 1.6665 6.74062 2.15525 5.37021 3.07092C3.9998 3.9866 2.9317 5.28809 2.30097 6.81081C1.67024 8.33353 1.50521 10.0091 1.82675 11.6256C2.1483 13.2421 2.94197 14.727 4.10741 15.8924C5.27284 17.0578 6.7577 17.8515 8.37421 18.173C9.99072 18.4946 11.6663 18.3296 13.189 17.6988C14.7117 17.0681 16.0132 16 16.9289 14.6296C17.8446 13.2592 18.3333 11.648 18.3333 9.99984C18.3333 8.90549 18.1177 7.82186 17.699 6.81081C17.2802 5.79976 16.6663 4.8811 15.8925 4.10728C15.1187 3.33346 14.2 2.71963 13.189 2.30084C12.1779 1.88205 11.0943 1.6665 9.99996 1.6665ZM9.99996 14.1665C9.83514 14.1665 9.67403 14.1176 9.53699 14.0261C9.39995 13.9345 9.29314 13.8043 9.23006 13.6521C9.16699 13.4998 9.15049 13.3322 9.18264 13.1706C9.2148 13.0089 9.29416 12.8605 9.41071 12.7439C9.52725 12.6274 9.67574 12.548 9.83739 12.5159C9.99904 12.4837 10.1666 12.5002 10.3189 12.5633C10.4711 12.6263 10.6013 12.7332 10.6929 12.8702C10.7844 13.0072 10.8333 13.1684 10.8333 13.3332C10.8333 13.5542 10.7455 13.7661 10.5892 13.9224C10.4329 14.0787 10.221 14.1665 9.99996 14.1665ZM10.8333 10.8332C10.8333 11.0542 10.7455 11.2661 10.5892 11.4224C10.4329 11.5787 10.221 11.6665 9.99996 11.6665C9.77895 11.6665 9.56699 11.5787 9.41071 11.4224C9.25443 11.2661 9.16663 11.0542 9.16663 10.8332V6.6665C9.16663 6.44549 9.25443 6.23353 9.41071 6.07725C9.56699 5.92097 9.77895 5.83317 9.99996 5.83317C10.221 5.83317 10.4329 5.92097 10.5892 6.07725C10.7455 6.23353 10.8333 6.44549 10.8333 6.6665V10.8332Z"
        fill="#FCB037"
      />
    </svg>
  );
};

const SummaryLimit = ({
  type = "",
  used = 0,
  limit = 0,
  onExplore = () => {},
}) => {
  const isReimbursement = type === "reimbursement";

  const isReachedLimit = used === limit;
  const isOverLimit = used > limit;

  const overLimitText = isReimbursement ? (
    <>
      Your company has reached reimbursement monthly limit. To continue, please
      remove{" "}
      <span style={{ fontFamily: "GothamMedium" }}>
        {used - limit} expense(s)
      </span>
      .
    </>
  ) : (
    <>
      Your company has reached invoice monthly limit. To continue, please remove{" "}
      <span style={{ fontFamily: "GothamMedium" }}>
        {used - limit} invoice(s)
      </span>
      .
    </>
  );

  const reachedLimitText = isReimbursement
    ? "Your company has reached its monthly limit for reimbursing receipts. For unlimited reimbursement, please upgrade your plan."
    : "Your company has reached its monthly limit for submitting bill payments. For unlimited limit, please upgrade your plan.";

  const limitText = isReimbursement
    ? "Number of reimbursement you can create this month:"
    : "Number of invoice you can submit this month:";

  const backgroundColor = isReachedLimit
    ? "#FFF6E6"
    : isOverLimit
    ? "#FFEEEE"
    : jackColors.greenB9;

  const border = isReachedLimit
    ? `1px solid ${jackColors.yellowFC}`
    : isOverLimit
    ? `1px solid ${jackColors.redE7}`
    : "";

  return (
    <div
      className={styles["summary-limit"]}
      style={{
        backgroundColor,
        border,
        borderBottom: "0px",
      }}
    >
      {isReachedLimit ? (
        <Fragment>
          <ExclamationMark />
          <GothamRegular
            woFontColor
            className="font12"
            style={{ color: jackColors.neutral900 }}
          >
            {reachedLimitText}{" "}
            <span
              style={{
                fontFamily: "GothamMedium",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={onExplore}
            >
              Explore plan
            </span>
          </GothamRegular>
        </Fragment>
      ) : isOverLimit ? (
        <Fragment>
          <AlertRed />
          <GothamRegular
            woFontColor
            className="font12"
            style={{ color: jackColors.neutral900 }}
          >
            {overLimitText}
          </GothamRegular>
        </Fragment>
      ) : (
        <Fragment>
          <QuestionMark />
          <GothamRegular
            woFontColor
            className="font12"
            style={{ color: jackColors.neutral900 }}
          >
            {limitText}
          </GothamRegular>
          <div>{limit - used}</div>
        </Fragment>
      )}
    </div>
  );
};

export default SummaryLimit;
